<template>
<div>
  <div v-for="item of init.skList"
  style="margin-bottom:25px"
  >
    <v-toolbar flat>
        <v-toolbar-title>
          {{item.name}}
        </v-toolbar-title>
    <v-spacer/>
   <v-icon @click="redact(item)" style="margin:5px">mdi-lead-pencil</v-icon>
   <v-icon @click="deleteSk(item.id)" style="margin:5px">mdi-close</v-icon>

    </v-toolbar>

  </div>
</div>
</template>

<script>

import axios from 'axios'
export default {
 components:{},
 props: ['filter','init'],
  data () {
    return {

    }
  },
methods: {
getSk(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/filter/get_list.php', {method: 'POST', data: { data: null }})
.then( response => {this.init.skList  = response.data})
},


redact(item){
this.init.isCreator = false
this.init.selectedFilterId = item.id
let params = JSON.parse(item.params)
this.filter.selectedType = params.selectedType
this.filter.types = params.types
this.filter.name = item.name
this.filter.weight = params.weight
this.filter.filters = params.filters
this.init.modals.creator = true
},


  redactConfirm(){
    // не нужный видимо !!!
      axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/scripts/redact.php', {
           method: 'POST',
           data: {
             id: this.redactItem.id,
             name : this.redactItem.name,
             path: this.redactItem.path,
             store: this.redactItem.store,
           }
         })
         .then( response => {
           this.skList  = response.data
           this.redactScriptModal = false
         })

  },



deleteSk(id){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/filter/delete.php', {
method: 'POST',
data: {id : id}
})
.then( response => { this.init.skList  = response.data})
},



},
computed:{
},
mounted(){
this.getSk()
},

}
</script>

<style    >

</style>
